import {ServiceLikeIconButton} from '@frontend/modules/public/services/components/list/ServiceLikeIconButton'
import type {ExecutorPreviewData} from '../../ServicesModuleTypes'

interface Props {
    executor: ExecutorPreviewData
    liked?: boolean
    disabled?: boolean
}

// Иконки для карточки исполнителя услуг (лайк).
export function ServicesListItemIcons(props: Props) {

    const {
        executor,
        liked = false,
        disabled,
    } = props

    return (
        <div className="executor-card-icons d-flex flex-column align-items-center justify-content-center">
            <ServiceLikeIconButton
                executor={executor}
                isFavourite={liked}
                noLabel
                white
                filled
                disabled={disabled}
                className="executor-card-icon btn-like p-1"
            />
        </div>
    )
}
